import {
  SequentialMockAdapter,
} from '@ama-sdk/core';
import {
  getMockAdapter,
  getMockScenario,
} from '@refx/shared-common';

export const importMockMaps = async () => (await import(/* webpackChunkName: "mocks" */'../configuration/mocks/mock-maps')).mockMaps;

/**
 * returns true iff the scenario is a path to a ALF logs file
 *
 * @param scenario scenario name provided as get/post parameter
 * @returns true iff the scenario is a path to a ALF logs file
 */
export function isAlfMockScenario(scenario?: string): boolean {
  return !!scenario && (scenario.endsWith('.bin') || scenario.endsWith('.raw'));
}

export const mockAdapter: SequentialMockAdapter = getMockAdapter(
  async () => {
    const maps = await importMockMaps();
    return maps[getMockScenario() || 'flexPremiumOneWay1AdtMock'];
  }
);
